import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Controller } from 'react-hook-form';
import Select, { components } from 'react-select';

function AdminSelect({ 
  control, options, name, classContainer, classLabel, classSelect, placeholder, classNamePrefix, label, isOptionnal, 
  defaultValue, scrollToValue,
  noLabel, noClear, isMulti, required, optionPersonnalize, SingleValue, focus, setFocus, tooltip, handleSelect, errors
 }) {

  const scrollTopOnSelect = () => {
    window.scrollTo({
      top: scrollToValue,
      left: 0,
      behavior: "smooth",
    });
  }

  // Permet de limiter le nombre maximum d'options à afficher
  const MenuList = ({ children, ...props }) => {
    const { maxOptions } = props.selectProps;
    return (
      <components.MenuList {...props}>
        {Array.isArray(children) ? children.slice(0, maxOptions) : children}
      </components.MenuList>
    );
  };

  const handleFocus = (menuIsOpen) => {
    setFocus && setFocus(menuIsOpen)
  }

  return(
    <Controller
      name={name} control={control} defaultValue={defaultValue || ''}
      rules={{ required: required ? 'Ce champ est requis' : false }}  // Ajout de la règle required
      render={({ field, fieldState }) => {
        return (
          <div className={classContainer}>
            {!noLabel && <p className={classLabel}>{label}{isOptionnal && <span className="optionnal">(optionnel)</span>}</p>}
            <Select
              {...field}
              components={optionPersonnalize ? { Option: optionPersonnalize, MenuList, SingleValue } : { MenuList }}
              isMulti={isMulti}
              maxOptions={70} 
              onMenuOpen={() => handleFocus(true)} // Appelé lorsque le menu s'ouvre
              onMenuClose={() => handleFocus(false)} // Appelé lorsque le menu se ferme
              options={options} className={`${classSelect} ${errors?.[name] ? 'border-2 border-red-600 outline-none' : ''}`} 
              classNamePrefix={classNamePrefix}
              isSearchable={true} isClearable={!noClear}
              placeholder={placeholder} 
              onChange={(selectedOption) => {
                field.onChange(selectedOption);
                handleSelect && handleSelect(selectedOption);
              }}
              onFocus={scrollToValue ? scrollTopOnSelect : null}
            />
            {(errors?.[name]) && 
              <p className={`font-semibold text-red-600 mt-2`}>
                <FontAwesomeIcon icon={faInfoCircle} className="mr-2"/>
                {errors[name]?.message}
              </p>
            }
          </div>
        )
      }}
    />
  )
}

export default AdminSelect